import _invert from 'lodash/invert';

import { AccountType } from './accountType';

/**
 * Represent our different "categories" of available account types, each currently is mapped to a account/entity type
 * or has additional sub-type selection options.
 */
export enum UmbrellaAccountType {
  INDIVIDUAL = 'INDIVIDUAL',
  ENTITY = 'ENTITY',
  RETIREMENT = 'RETIREMENT',
}

export const UMBRELLA_ACCOUNT_TYPE_TO_ACCOUNT_TYPE: Record<UmbrellaAccountType, AccountType> = {
  [UmbrellaAccountType.INDIVIDUAL]: AccountType.INDIVIDUAL,
  [UmbrellaAccountType.RETIREMENT]: AccountType.CHECKBOOK_IRA,
  [UmbrellaAccountType.ENTITY]: AccountType.ENTITY,
};

export const ACCOUNT_TYPE_TO_UMBRELLA_ACCOUNT_TYPE = _invert(
  UMBRELLA_ACCOUNT_TYPE_TO_ACCOUNT_TYPE
) as unknown as Record<AccountType.INDIVIDUAL | AccountType.ENTITY | AccountType.CHECKBOOK_IRA, UmbrellaAccountType>;
